export function normalizeMessages(messages) {
    return Array.isArray(messages) ? messages : [];
}

export function getResponseData(response) {
    return (
        response &&
        response.data &&
        response.data.data
    )
        ? response.data.data
        : {};
}

export function mergeMessageLists(
    primaryMessages,
    secondaryMessages
) {
    const result = [];
    const seenIds = Object.create(null);
    const lists = [
        normalizeMessages(primaryMessages),
        normalizeMessages(secondaryMessages)
    ];

    lists.forEach((messages) => {
        messages.forEach((message) => {
            if (!message) {
                return;
            }

            if (
                message.id === undefined ||
                message.id === null
            ) {
                result.push(message);
                return;
            }

            const messageKey = String(message.id);

            if (!seenIds[messageKey]) {
                seenIds[messageKey] = true;
                result.push(message);
            }
        });
    });

    return result;
}

export function getMessageId(message) {
    if (!message) {
        return null;
    }

    if (
        message.id !== undefined &&
        message.id !== null
    ) {
        return message.id;
    }

    if (!message.chat_data) {
        return null;
    }

    return message.chat_data.message_id !== undefined
        ? message.chat_data.message_id
        : message.chat_data.id;
}

export function isSelfMessage(message, selfUserId) {
    return Boolean(
        message &&
        message.sender &&
        String(message.sender.user_id) ===
            String(selfUserId)
    );
}

export function getAxiosErrorMessage(
    error,
    fallbackMessage
) {
    const responseData =
        error &&
        error.response &&
        error.response.data;

    if (!responseData) {
        return fallbackMessage;
    }

    return (
        responseData.msg ||
        responseData.message ||
        fallbackMessage
    );
}
